export default __webpack_public_path__ + "static/media/user-new.19b4eed8.svg";